import { render, staticRenderFns } from "./BizBusinessinfoList.vue?vue&type=template&id=36db9643&"
import script from "./BizBusinessinfoList.vue?vue&type=script&lang=js&"
export * from "./BizBusinessinfoList.vue?vue&type=script&lang=js&"
import style0 from "./BizBusinessinfoList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports